const state = {
  imageZoomData: {},
  imageZoomActive: false,
};

const mutations = {
  CHANGE_IMAGE_ZOOM_CONTENT(state, imageZoomData) {
    state.imageZoomData = imageZoomData;
  },
  IMAGE_ZOOM_ACTIVATE(state) {
    state.imageZoomActive = true;
  },
  IMAGE_ZOOM_DEACTIVATE(state) {
    state.imageZoomActive = false;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  imageZoomData: (state) => {
    return state.imageZoomData;
  },
  imageZoomActive: (state) => {
    return state.imageZoomActive;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
